import React, { useEffect, useRef, useState } from 'react';

// Truncamento explícito (nunca só hover) — só mostra "Ver mais" quando o
// texto realmente não cabe em 2 linhas (mede via scrollHeight depois de
// renderizar), e sempre deixa o texto completo alcançável por clique, nunca
// escondido de vez. Padrão comum em texto longo dentro de lista/tabela.
const TextoTruncavel = ({ texto }) => {
  const [expandido, setExpandido] = useState(false);
  const [precisaTruncar, setPrecisaTruncar] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      setPrecisaTruncar(ref.current.scrollHeight > ref.current.clientHeight + 1);
    }
  }, [texto]);

  return (
    <div>
      <p ref={ref} className={expandido ? 'break-words' : 'line-clamp-2 break-words'}>
        {texto}
      </p>
      {precisaTruncar && (
        <button
          type="button"
          onClick={() => setExpandido((v) => !v)}
          aria-expanded={expandido}
          className="text-xs font-medium text-primary-600 hover:text-primary-700 mt-1"
        >
          {expandido ? 'Ver menos' : 'Ver mais'}
        </button>
      )}
    </div>
  );
};

export default TextoTruncavel;
